import { baseApi as api } from "../../../contexts/endpoints/base_api";

const injectedApi = api.injectEndpoints({
  endpoints: (build) => ({
    getMakerLicenses: build.query<
      GetMakerLicensesApiResponse,
      GetMakerLicensesApiArg
    >({
      query: () => ({ url: `/api/account/maker` }),
      providesTags: ["MakerLicenses"],
    }),
    getMakerLicenseDetails: build.query<
      GetMakerLicenseDetailsApiResponse,
      GetMakerLicenseDetailsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/account/maker/${queryArg.licenseKey}`,
      }),
    }),
    postMakerLicense: build.mutation<
      PostMakerLicenseApiResponse,
      PostMakerLicenseApiArg
    >({
      query: () => ({ url: `/api/account/maker`, method: "POST" }),
      invalidatesTags: ["MakerLicenses"],
    }),
    deleteMakerLicense: build.mutation<
      DeleteMakerLicenseApiResponse,
      DeleteMakerLicenseApiArg
    >({
      query: (queryArg) => ({
        url: `/api/account/maker/${queryArg.licenseKey}`,
        method: "DELETE",
      }),
      invalidatesTags: ["MakerLicenses"],
    }),
    postMakerLicenseName: build.mutation<
      PostMakerLicenseNameApiResponse,
      PostMakerLicenseNameApiArg
    >({
      query: (queryArg) => ({
        url: `/api/account/maker/${queryArg.licenseKey}/licenseName`,
        method: "POST",
        body: queryArg.licenseNamePayload,
      }),
      invalidatesTags: ["MakerLicenses"],
    }),
    postMakerInvalidateSession: build.mutation<
      PostMakerInvalidateSessionApiResponse,
      PostMakerInvalidateSessionApiArg
    >({
      query: (queryArg) => ({
        url: `/api/account/maker/invalidateSession`,
        method: "POST",
        body: queryArg.licenseKeyPayload,
      }),
      invalidatesTags: ["MakerLicenses"],
    }),
    postGenerateActivationToken: build.mutation<
      PostGenerateActivationTokenApiResponse,
      PostGenerateActivationTokenApiArg
    >({
      query: (queryArg) => ({
        url: `/api/account/maker/generateActivationToken`,
        method: "POST",
        body: queryArg.licenseKeyPayload,
      }),
    }),
  }),
  overrideExisting: false,
});

export type GetMakerLicensesApiResponse =
  /** status 200 OK */ GetMakerLicenseSummeryListResponse;
export type GetMakerLicensesApiArg = void;
export type GetMakerLicenseDetailsApiResponse =
  /** status 200 OK */ MakerLicenseDetailsResponse;
export interface GetMakerLicenseDetailsApiArg {
  licenseKey: string;
}
export type PostMakerLicenseApiResponse =
  /** status 200 OK */ CreateMakerLicenseResponse;
export type PostMakerLicenseApiArg = void;
export type DeleteMakerLicenseApiResponse = /** status 200 OK */ object;
export interface DeleteMakerLicenseApiArg {
  licenseKey: string;
}
export type PostMakerLicenseNameApiResponse = /** status 200 OK */ object;
export interface PostMakerLicenseNameApiArg {
  licenseKey: string;
  licenseNamePayload: LicenseNamePayload;
}
export type PostMakerInvalidateSessionApiResponse = /** status 200 OK */ object;
export interface PostMakerInvalidateSessionApiArg {
  licenseKeyPayload: LicenseKeyPayload;
}
export type PostGenerateActivationTokenApiResponse =
  /** status 200 OK */ GenerateTokenMakerLicenseResponse;
export interface PostGenerateActivationTokenApiArg {
  licenseKeyPayload: LicenseKeyPayload;
}

export interface MakerLicenseSummaryItem {
  key: string;
  name?: string;
  status: "ACTIVE" | "AVAILABLE";
}
export interface GetMakerLicenseSummeryListResponse {
  licenses: MakerLicenseSummaryItem[];
}
export interface CreateMakerLicenseResponse {
  licenseKey: string;
}
export interface LicenseNamePayload {
  licenseName: string;
}
export interface LicenseKeyPayload {
  licenseKey: string;
}
export interface GenerateTokenMakerLicenseResponse {
  activationToken: string;
  licenseKey: string;
}
export interface LicenseSession {
  gatewayName: string;
  ipAddress: string;
  validated: string;
  checkIn: string;
  expiration: string;
}
export interface ModulePropertiesParameter {
  name: string;
  value: string;
}
export interface MakerLicenseModule {
  version: string;
  parameters: ModulePropertiesParameter[];
}
export interface MakerLicenseDetailsResponse {
  name?: string;
  key: string;
  status: "ACTIVE" | "AVAILABLE";
  sessions: LicenseSession[];
  coreModules: MakerLicenseModule[];
  thirdPartyModules: MakerLicenseModule[];
}

export const {
  useGetMakerLicensesQuery,
  useGetMakerLicenseDetailsQuery,
  usePostMakerLicenseMutation,
  useDeleteMakerLicenseMutation,
  usePostMakerLicenseNameMutation,
  usePostMakerInvalidateSessionMutation,
  usePostGenerateActivationTokenMutation,
} = injectedApi;
